import * as React from "react";
const SvgFiRrHandHoldingSeeding = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-holding-seeding_svg__a)">
      <path
        fill="#062147"
        d="m23.047 17.197-4.318 3.935a10.98 10.98 0 0 1-7.408 2.867H1a1 1 0 1 1 0-2h10.32a8.98 8.98 0 0 0 6.061-2.346l4.284-3.902c.347-.348.43-.944.156-1.324a1 1 0 0 0-.74-.425 1.02 1.02 0 0 0-.788.29l-4.234 3.887a3 3 0 0 1-2.059.82H9a1 1 0 1 1 0-2h5c.252 0 1-.114 1-1a1 1 0 0 0-1-1H9.088a8.95 8.95 0 0 0-6.364 2.637l-.998 1.053a1 1 0 1 1-1.451-1.376l1.017-1.072a10.95 10.95 0 0 1 7.797-3.24h4.912c1.236 0 2.3.753 2.759 1.822l2.151-1.973a2.96 2.96 0 0 1 2.331-.84c.88.07 1.683.526 2.203 1.249.844 1.173.673 2.866-.397 3.939zM4.006 2.162A2.01 2.01 0 0 1 4.594.594 2 2 0 0 1 6.163.006C9.04.209 10.948 1.2 12 3.118 13.053 1.2 14.96.208 17.838.006a1.98 1.98 0 0 1 1.568.588c.416.415.63.987.588 1.569-.311 4.413-2.48 6.545-6.994 6.808v1.028a1 1 0 1 1-2 0V8.97c-4.514-.264-6.683-2.395-6.994-6.81m9.026 4.806C16.393 6.744 17.766 5.33 18 2.022c-3.329.214-4.744 1.585-4.968 4.946M6.021 2c.214 3.329 1.585 4.744 4.946 4.968C10.743 3.607 9.33 2.234 6.021 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-holding-seeding_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandHoldingSeeding;
